import { render, staticRenderFns } from "./VerifyTel.vue?vue&type=template&id=caa381f8&scoped=true&"
import script from "./VerifyTel.vue?vue&type=script&lang=js&"
export * from "./VerifyTel.vue?vue&type=script&lang=js&"
import style0 from "./VerifyTel.vue?vue&type=style&index=0&id=caa381f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "caa381f8",
  null
  
)

export default component.exports